import GridItem from "../../componentsv2/GridItem";
import React from "react";
import Tabela from "./components/Tabela";
import Header from "../../components/Header";
import Container from "../../componentsv2/Container";

export default function VisualizarBI() {
  return (
    <>
      <Header titulo="Central de BI´S"/>
      <Container>
        <GridItem>
          <Tabela/>
        </GridItem>
      </Container>
    </>
  );
}
